export const trackPageView = () => {
  window.dataLayer && window.dataLayer.push({
    event: 'Pageview',
    url: window.location.href,
    path: window.location.pathname
  })

  window.analytics && window.analytics('config', 'UA-21037369-11', {
    page_location: window.location.href,
    page_path: window.location.pathname
  })
}

export const trackContentGroup = (category: string) => {
  const analyticsCategory = {
    specialPacks: 'packs_especiales',
    beer: 'cervezas',
    glassware: 'cristaleria'
  }[category]

  window.dataLayer && window.dataLayer.push({
    pageContentGroup: analyticsCategory
  })
}

export const trackFormSubmit = (formName: string, error: boolean) => {
  window.dataLayer &&
    window.dataLayer.push({
      event: formName,
      formError: error
    })
}
